module.exports = __webpack_public_path__ + "static/img/credenPhotoback.27b9753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/credenPhotoback.png
// module id = TOnB
// module chunks = 5